var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 37.5V43.75C22.9167 44.8958 21.9792 45.8333 20.8333 45.8333C19.6875 45.8333 18.75 44.8958 18.75 43.75V37.5H22.9167Z",
    fill: "#D9DBE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2487 37.5V43.75C31.2487 44.8958 30.3112 45.8333 29.1654 45.8333C28.0195 45.8333 27.082 44.8958 27.082 43.75V37.5H31.2487Z",
    fill: "#D9DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4154 22.9167V33.3333C35.4154 35.625 33.5404 37.5 31.2487 37.5H18.7487C16.457 37.5 14.582 35.625 14.582 33.3333V22.9167C14.582 20.625 16.457 18.75 18.7487 18.75H31.2487C33.5404 18.75 35.4154 20.625 35.4154 22.9167Z",
    fill: "#D9DBE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 22.9167V31.25C10.4167 32.3959 9.47917 33.3334 8.33333 33.3334C7.1875 33.3334 6.25 32.3959 6.25 31.25V22.9167C6.25 21.7709 7.1875 20.8334 8.33333 20.8334C9.47917 20.8334 10.4167 21.7709 10.4167 22.9167Z",
    fill: "#D9DBE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7487 22.9167V31.25C43.7487 32.3959 42.8112 33.3334 41.6654 33.3334C40.5195 33.3334 39.582 32.3959 39.582 31.25V22.9167C39.582 21.7709 40.5195 20.8334 41.6654 20.8334C42.8112 20.8334 43.7487 21.7709 43.7487 22.9167Z",
    fill: "#D9DBE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 15.8333H30.0014C31.8347 15.8333 33.3346 14.3333 33.3346 12.5C33.3346 7.89579 29.6055 4.16663 25.0013 4.16663C20.3971 4.16663 16.668 7.89579 16.668 12.5C16.668 14.3333 18.1679 15.8333 20.0013 15.8333Z",
    fill: "#D9DBE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.4a9972abbbba382fc42ea0b7dddc0766.svg";
export { ForwardRef as ReactComponent };